module.exports = __webpack_public_path__ + "static/media/creditCard.f505e0bb.png";